import React from "react";
import Navigation from "../Navigation";
import LeftContainer from "../TicketsPage/LeftContainer";
import useBasketManager from "../Basket/useBasketManager";
import useTypeSale from "../../../utils/hooks/useTypeSale";
import { FINALIZE_PAGE, REALIZE_VOUCHER_PAGE, TICKETS_PAGE } from "../../routes";
import { useNavigate } from "react-router";
import "./style.scss";
import Calendar from "./Calendar";
import ReturnButton from "../../../features/ReturnButton";
import useExerciseManager from "./hooks/useExerciseManager";
import ExerciseSelect from "./ExerciseSelect";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import { BASKET_CALCULATE_PROMOTION, EXERCISE_BASKET_CLEAR } from "../../api/apiRoutes";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import { REALIZE_VOUCHER } from "../../models/TypeSale";
import { viewCart } from "../../ga4/gaMethods";

const ExercisePage: React.FC = () => {
  const navigate = useNavigate();
  const isDesktop = useDesktopSize();
  const { get, post } = useApiRequest();
  const { isSaleWithExercise, colorClass, typeSale, categoryBrand } = useTypeSale();
  const {
    basket,
    setBasket,
    addExerciseToBasket,
    disabledFinalizeBtn,
    totalListPrice,
    removeWholeBasket,
    removeBasket
  } = useBasketManager(isSaleWithExercise);
  const {
    onSelectDate,
    getPrice,
    getPromotionPrice,
    exerciseList,
    changeMonth,
    getPokazujDO,
    getSelectedDay,
    getDisabledDay,
    activeSelectExercise,
    setActiveSelectExercise
  } = useExerciseManager(basket, setBasket, addExerciseToBasket);

  const navigateToFinalize = () => {
    viewCart(basket, categoryBrand, totalListPrice);
    if (typeSale) {
      navigate(`${FINALIZE_PAGE}?isSaleWithExercise=${isSaleWithExercise}&typeSale=${typeSale}`);
    } else {
      navigate(`${FINALIZE_PAGE}?isSaleWithExercise=${isSaleWithExercise}`);
    }
  };

  const finalizeButtonText = disabledFinalizeBtn() ? "Wybierz przedział czasowy" : "Przejdź do podsumowania";
  const isExerciseSelect = Boolean(exerciseList.length > 0 && basket.length > 0);
  const isRealizeVoucher = typeSale === REALIZE_VOUCHER;

  const returnToTicketPage = async () => {
    const { isError } = await post(EXERCISE_BASKET_CLEAR);
    if (!isError) {
      await get(BASKET_CALCULATE_PROMOTION("", true));
    }
    if (typeSale === REALIZE_VOUCHER) {
      navigate(`${REALIZE_VOUCHER_PAGE}?isSaleWithExercise=true`);
    } else {
      navigate(`${TICKETS_PAGE}?isSaleWithExercise=${isSaleWithExercise}`);
    }
  };

  return (
    <Navigation>
      <div className={"sale-panel"}>
        <div className={"exercise-panel"}>
          <p className={"title"}>Wybierz dzień</p>
          <p className={"description"}>
            {typeSale !== REALIZE_VOUCHER ? `Bilet popołudniowy dostępny jest od poniedziałku do czwartku!` : ""}
          </p>
          <Calendar
            onSelectDate={onSelectDate}
            getPrice={getPrice}
            getPricePromotion={getPromotionPrice}
            onChangeMonth={changeMonth}
            getPokazujDo={getPokazujDO}
            getSelectedDay={getSelectedDay}
            // maxDate={new Date(2023, 10, 1)}
            // minDate={new Date(2023, 5, 1)}
            getDisabledDay={getDisabledDay}
          />
          <div id={"exercise-group-panel"}>
            {isExerciseSelect && (
              <ExerciseSelect
                exerciseList={exerciseList}
                onSelect={addExerciseToBasket}
                select={activeSelectExercise}
                setSelect={setActiveSelectExercise}
              />
            )}
          </div>
          {isDesktop && <ReturnButton onClick={() => returnToTicketPage()} />}
        </div>
        <LeftContainer
          colorClass={colorClass}
          basket={basket}
          onRemoveToBasket={isRealizeVoucher ? removeBasket : removeWholeBasket}
          updateBasket={setBasket}
          onNavigateFinalize={navigateToFinalize}
          finalizeButtonText={finalizeButtonText}
          isSaleWithExercise={isSaleWithExercise}
          disabledFinalizeBtn={disabledFinalizeBtn()}
          totalListPrice={totalListPrice}
          title={isRealizeVoucher ? "Zrealizuj voucher" : "Twój koszyk"}
          typeSale={typeSale}
          isWeatherTicket={!isRealizeVoucher}
        />
      </div>
    </Navigation>
  );
};

export default ExercisePage;
